import UserOptionCache from '@/utils/cache-data/src/user-option.ts'

export default {
  namespaced: true,

  state: {
    userOption: {}
  },

  getters: {},

  mutations: {
    /**
     * @description xét trạng thái option: true hay false
     * @param {*} state
     * @param {*} option
     */
    setUserOption (state, option) {
      state.userOption[option.Id] = option.Value
    }
  },

  actions: {
    /**
     * Lưu UserOption: show introduce trong màn làm bài tập từ phiếu tải lên
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async saveUserOption (context, param) {
      // Lưu UserOption vào trong Db
      const res = await UserOptionCache.SaveUserOption(param)
      if (res) {
        // Lấy UserOption từ IndexDB
        const result = await UserOptionCache.GetUserOption(param.OptionID)
        if (result) {
          // Nếu thành công thì gán giá trị cho state
          var option = {
            Id: result.OptionID,
            Value: result.OptionValue
          }
          context.commit('setUserOption', option)
        }
        return result
      }
    },

    /**
     * @description Lấy ra UserOption thông qua OptionID từ IndexDB
     * @param {*} context
     * @param {*} param
     * @returns
     */
    getUserOption (context, param) {
      return new Promise((resolve, reject) => {
        UserOptionCache.GetUserOption(param)
          .then((res) => {
            if (res) {
              // Nếu thành công thì gán giá trị cho state
              var option = {
                Id: res.OptionID,
                Value: res.OptionValue
              }
              context.commit('setUserOption', option)
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
